<script setup lang="ts">
const props = defineProps<{
  label?: string
  errorMessage?: string
}>()
</script>

<template>
  <div class="form-field" :class="{ error: props.errorMessage }">
    <label>
      <div v-if="props.label" class="label">{{ props.label }}</div>
      <slot />
    </label>
    <div v-if="props.errorMessage" class="error">
      {{ props.errorMessage }}
    </div>
  </div>
</template>
